export const data = {
    name: "Contacts",
    layout: [],
};
export default data;